import React from 'react'
import { func } from 'prop-types'
import { css } from '@emotion/core'
import { NoticeLoading } from '@fs/zion-icon'
import useYearPickerGenerations from '../useYearPickerGenerations'
import GenerationGroup from '../GenerationGroup'
import useDSApplicationMode from '../../../../../shared/hooks/useDSApplicationMode'

const centerWrapper = css`
  display: flex;
  justify-content: center;
`

export default function YearPickerAncestors({ personTileClickHandler }) {
  const generations = useYearPickerGenerations()
  const inDiscoveryCenter = useDSApplicationMode() === 'STATION'

  return generations.length === 0 ? (
    <div css={centerWrapper}>
      <NoticeLoading size="xl" />
    </div>
  ) : (
    generations
      .filter((generation) => generation?.people?.length > 0)
      .map((generation) => {
        return (
          <GenerationGroup
            key={generation.nameTranslationKey}
            generation={generation}
            inDiscoveryCenter={inDiscoveryCenter}
            onPersonTileClick={(person) => personTileClickHandler(person)}
          />
        )
      })
  )
}

YearPickerAncestors.propTypes = {
  personTileClickHandler: func,
}
